import { format, parse } from "date-fns";

export function formatDate(date) {
  const parseDate = parse(date, "yyyy/MM/dd", new Date());
  return format(parseDate, "dd/MM/yyyy");
}
